import React, { Component } from 'react';
import { View, Image, FlatList, Linking, TouchableOpacity } from 'react-native';
import { inject, observer } from "mobx-react";
import { componentStyles, appStyles } from '../theme/styles';
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor } from '../theme/colors';
import { icons } from '../theme/icons';
import TextView from './TextView';
import {priceString, showPrompt} from '../utils/utils';
import { supportNumberRequest, logoutRequest } from '../utils/api';
import Waiting from './Waiting';
import { clearUsers } from '../database/UserDal';
import DialogPrompt from './DialogPrompt';

@inject('store')
@observer
export default class DrawerUi extends Component {

    constructor(props) {
        super(props)
        this.state = {
            waiting: false,
            sharge: 0,
            showPrompt: false,
            promptMessage: '',
            items: [
                { icon: 'avatar', title: 'اطلاعات کاربری' },
                { icon: 'requests', title: 'لیست درخواست ها' },
                { icon: 'wallet', title: '' },
                { icon: 'star_m', title: 'اشخاص منتخب' },
                { icon: 'nurse_menu', title: 'درمانگران منتخب' },
                { icon: 'pinmap', title: 'آدرس های منتخب' },
                { icon: 'setting', title: 'تنظیمات' },
                { icon: 'diamond', title: 'کد آد شما' },
                { icon: 'notifiction', title: 'صندوق پیام' },
                { icon: 'emailbox', title: 'انتقادات و پیشنهادات' },
                { icon: 'ad_logo', title: 'درباره آد' },
                { icon: 'support', title: 'پشتیبانی' },
                { icon: 'law', title: 'قوانین و مقررات' },
                { icon: 'logout', title: 'خروج از سیستم' },
            ]
        };

    }
    _keyExtractor = (item, index) => index.toString();
    renderRow({ item, index }) {
        return <TouchableOpacity style={componentStyles.menuItem} onPress={() => {
            console.log('click')
            this.props.store.changeAutoPlay(false)
            this.props.navigation.closeDrawer()
            if (index == 0) {
                this.props.navigation.navigate('profile')
            } else if (index == 1) {
                this.props.navigation.navigate('requestList')
            } else if (index == 2) {
                this.props.navigation.navigate('wallet')
            } else if (index == 3) {
                this.props.navigation.navigate('favoritPerson')
            } else if (index == 4) {
                this.props.navigation.navigate('favoritExpert')
            } else if (index == 5) {
                this.props.navigation.navigate('favoritAddress')
            } else if (index == 6) {
                this.props.navigation.navigate('setting', {
                    rootNavigation: this.props.navigation,
                })
            } else if (index == 7) {
                this.props.navigation.navigate('code')
            } else if (index == 8) {
                this.props.navigation.navigate('notifiction')
            } else if (index == 9) {
                this.props.navigation.navigate('support')
            } else if (index == 10) {
                this.props.navigation.navigate('aboutus')
            } else if (index == 11) {
                this.setState({
                    waiting: true,
                })
                supportNumberRequest((isConnect, response) => {
                    this.setState({
                        waiting: false
                    })
                    if (isConnect && response.isSuccess) {
                        Linking.openURL('tel:' + response.data.support_number);
                    }
                })
            } else if (index == 12) {
                this.props.navigation.navigate('rules')
            } else if (index == 13) {
                showPrompt('','آیا میخواهید از حساب کاربری خود خارج شوید ؟',()=>{
                    this.logout();
                })

            }
        }}>
            <TextView>{item.title}{index == 2 ? (priceString(this.state.sharge) + ' تومان (شارژ حساب)') : ''}</TextView>
            <Image source={icons[item.icon]} style={componentStyles.menuIcon} />
        </TouchableOpacity>
    }
    render() {
        return (
            <View style={{ flex: 1 }}>
                <LinearGradient colors={[blueLightColor, blueDarkColor]} style={componentStyles.menuHeaderWraper}>
                    <TouchableOpacity onPress={() => {
                        this.props.navigation.closeDrawer()
                    }}>
                        <Image source={icons['right_arrow']} style={[appStyles.toolbarIcon,{tintColor:'white'}]} />
                    </TouchableOpacity>
                    <TextView style={componentStyles.menuTitle}>آد ، حس خوب سلامتی در خانه</TextView>
                    <Image source={icons['ad_logo']} style={appStyles.adLogo} />
                </LinearGradient>
                <FlatList
                    data={this.state.items}
                    extraData={this.state}
                    ListFooterComponent={() => {
                        return <View style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <TextView style={{ color: 'grey', textAlign: 'center' }}>ورژن ۱.۱.۸</TextView>
                        </View>
                    }}
                    renderItem={this.renderRow.bind(this)}
                    keyExtractor={this._keyExtractor} />
                <Waiting waiting={this.state.waiting} />
                <DialogPrompt
                    show={this.state.showPrompt}
                    message={this.state.promptMessage}
                    approve='بله'
                    cancel='خیر'
                    onApprove={() => {
                        this.setState({
                            showPrompt: false
                        }, () => {
                            this.logout();
                        })


                    }}
                    onCancel={() => {
                        this.setState({
                            showPrompt: false
                        })

                    }}
                    onClose={() => {
                        this.setState({
                            showPrompt: false
                        })
                    }} />
            </View>
        );
    }
    logout() {
        logoutRequest((isConnect, response) => {
            clearUsers();
            Linking.openURL('https://client.asandarman.ir');
        })

    }
    componentWillReceiveProps(newprops) {
        this.setState({
            sharge: this.props.store.wallet_amount
        })
    }

}

